<template lang="pug">
  #business-list
    .table-view
      .table-view-header
        .table-view-header-title
          h3 Empresas
        .table-view-header-actions
          b-button(@click="onDeleteAll" style="min-width: 150px" variant="outline-primary") Desactivar todo
          b-button(@click="onCreateAll" style="min-width: 150px") Activar todo
      b-table(:items="tableItems" :fields="fields" responsive)
        template(v-slot:cell(name)="{item}")
          router-link(:to="{ name:'BusinessDetail', params:{ id: item.bussinesId } }") {{item.name}}
        template(v-slot:cell(rut)="{value}")
          div(style="min-width: 130px;") {{value}}
        template(v-slot:cell(startDate)="{item, value}")
          div(style="min-width: 100px; max-width: 150px;")
            BaseInputConfirmChange(
              v-model="item.form.startDate"
              @change="onSave(item.form)"
              type="date"
              :disabled="!item.active"
              size="sm"
            )
        template(v-slot:cell(active)="{item}")
          .table-actions
            b-form-checkbox(v-model="item.active" @change="onCreateOrDelete($event, item.form)" switch)
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import BaseInputConfirmChange from '../common/BaseInputConfirmChange.vue'

export default {
  components: {
    BaseInputConfirmChange
  },
  data() {
    return {
      fields: [
        {
          label: 'Nombre',
          key: 'name',
          sortable: true
        },
        {
          label: 'RUT',
          key: 'rut',
          sortable: true
        },
        {
          label: 'Fecha Inicio',
          key: 'startDate',
          sortable: true
        },
        {
          label: 'Activo',
          key: 'active',
          sortable: true
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['businesses', 'task']),
    tableItems () {
      if (!this.task.businessInTask) {
        return []
      }
      return this.businesses.map((b) => {
        const businessInTask = this.task.businessInTask.find(bt => bt.businessId === b.id)
        return {
          bussinesId: b.id,
          name: b.name,
          rut: b.rut,
          startDate: businessInTask ? businessInTask.startDate : '-',
          active: businessInTask ? true : false,
          form: {
            businessId: b.id,
            id: businessInTask ? businessInTask.id : undefined,
            startDate: businessInTask ? businessInTask.startDate : this.$options.filters.dateFormat(new Date(), 'YYYY-MM-DD')
          }
        }
      })
    },
  },
  methods: {
    ...mapActions(['deleteAllBusinessInTask', 'createAllBusinessInTask', 'listBusiness', 'addBusinessInTask', 'updateBusinessInTask', 'deleteBusinessInTask', 'getTask']),
    async onSave (data) {
      if (data.id) {
        await this.updateBusinessInTask({ data, taskId: this.task.id, businessId: data.businessId })
      } else {
        await this.addBusinessInTask({ data, taskId: this.task.id, businessId: data.businessId })
      }
      this.fetchData()
    },
    async onCreateAll () {
      await this.createAllBusinessInTask({ taskId: this.task.id, data: { startDate: '2021-01-01' } })
      this.fetchData()
    },
    async onDeleteAll () {
      await this.deleteAllBusinessInTask({ taskId: this.task.id })
      this.fetchData()
    },
    async onCreateOrDelete (onCreate, data) {
      if (onCreate) {
        await this.addBusinessInTask({ data, taskId: this.task.id, businessId: data.businessId })
      } else {
        await this.deleteBusinessInTask({ taskId: this.task.id, businessId: data.businessId })
      }
      this.fetchData()
    },
    fetchData () {
      this.getTask(this.$route.params.taskId)
    }
  },
  created() {
    this.fetchData()
    this.listBusiness()
  }
}
</script>
